import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({})
export default class Pagination extends Vue {
  @Prop({ default: null }) totalPages;
  @Prop({ default: null }) currentPage;
  @Prop({ default: null }) perPage;
  @Prop({ default: null }) totalObjects;

  goToPreviousPage() {
    if (this.currentPage > 1) this.$emit("previous-page");
  }

  goToNextPage() {
    if (this.currentPage < this.totalPages) this.$emit("next-page");
  }
}
